import React from "react";
import { Helmet } from "react-helmet-async";
import { useSeoMetadata } from "@/hooks/useSeoMetadata";

/**
 * Baseline site-wide JSON-LD injector: Organization + WebSite (with
 * SearchAction) — everything derived from CMS SiteSettings via
 * `/api/seo/site-metadata`. Mount once at the Shell level so every
 * page (including ones that use raw <Helmet>) automatically carries
 * these two schemas. Never emits per-page metadata (title, canonical,
 * og:*) — those remain the responsibility of individual pages.
 */
export default function SiteSchemas() {
  const { data: seoMeta } = useSeoMetadata();
  const schemas = [seoMeta?.organizationSchema, seoMeta?.websiteSchema].filter(Boolean);
  if (schemas.length === 0) return null;
  return (
    <Helmet>
      {schemas.map((s, i) => (
        <script
          key={`site-schema-${s?.["@type"] || i}`}
          type="application/ld+json"
        >
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
